import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';

// Material UI
import IconButton from '@mui/material/IconButton';
import Tooltip from '@mui/material/Tooltip';
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
import ListItemIcon from '@mui/material/ListItemIcon';
import ListItemText from '@mui/material/ListItemText';
import { useTheme } from '@mui/material';

// Icons
import AccountBalanceWalletIcon from '@mui/icons-material/AccountBalanceWallet';
import PaymentIcon from '@mui/icons-material/Payment';
import CloseIcon from '@mui/icons-material/Close';
import { ReactComponent as PosnetIcon } from '../../../../icons/posnet.svg';

// Components
import { PaymentDetails as SharedPaymentDetails } from '@arredo/reactjs-ui'

import { CanContinuePayment, CanRedirecToRefundView, onRedirectToRefundView } from '../../../../models/OrderEntity';

// Hooks
import useUser from "../../../../hooks/user/useUser";
import useAuthorize from '../../../../hooks/user/useAuthorize';
import useNotify from '../../../../hooks/notify';

// Others
import { Permissions } from '../../../../models/Roles';
import { PaymentStates } from '../../../../models/PaymentStates';

const PaymentDetails = ({ order = {}, onPaymentsCancelation }) => {
    const { currency = 'ARS', payments = [] } = order;
    const { branch, pv } = useUser();
    const isAuthorized = useAuthorize();
    const [menuRef, setMenuRef] = useState(null);
    const { Notify, variants } = useNotify();
    const push = useNavigate();
    const theme = useTheme();

    const continuePayment = () => {
        const payment = payments?.find(p => p.state === PaymentStates.Initialized)
        if (payment)
            window.location.href = payment.paymentUrl;
        else
            Notify('Hubo un problema al iniciar el pago.', variants.ERROR);

        setMenuRef(null);
    }

    const cancelPayment = async () => {
        const orderCancel = await onPaymentsCancelation();
        if (orderCancel) {
            push(`/orders/${orderCancel.id}`);
        } else
            Notify('Hubo un problema al cancelar el pago.', variants.ERROR);

        setMenuRef(null);
    }

    return (
        <SharedPaymentDetails
            currency={currency}
            payments={payments}
            perceptions={order?.perceptions}
            actions={
                isAuthorized([Permissions.SalesPayment]) &&
                <>
                    {CanRedirecToRefundView(order) && pv?.hasTerminal &&
                        <Tooltip title='Ir a devoluciones en proceso' aria-label='Devoluciones'>
                            <IconButton onClick={() => onRedirectToRefundView(order)} size='large'>
                                <PosnetIcon style={{ width: '1.45rem', height: '1.45rem', fill: theme.palette.primary.main }} />
                            </IconButton>
                        </Tooltip>
                    }
                    {CanContinuePayment(order, branch.code) &&
                        <>
                            <Tooltip title='Menu de pago' aria-label='Menu de pago'>
                                <IconButton
                                    color='primary'
                                    onClick={(event) => setMenuRef(event.currentTarget)}
                                    size='large'
                                >
                                    <AccountBalanceWalletIcon />
                                </IconButton>
                            </Tooltip>
                            <Menu
                                id='simple-menu'
                                keepMounted
                                anchorEl={menuRef}
                                open={Boolean(menuRef)}
                                onClose={() => setMenuRef(null)}
                            >
                                <MenuItem onClick={continuePayment}>
                                    <ListItemIcon>
                                        <PaymentIcon fontSize='small' />
                                    </ListItemIcon>
                                    <ListItemText primary='Continuar pago' />
                                </MenuItem>
                                <MenuItem onClick={cancelPayment}>
                                    <ListItemIcon>
                                        <CloseIcon fontSize='small' />
                                    </ListItemIcon>
                                    <ListItemText primary='Cancelar Pago' />
                                </MenuItem>
                            </Menu>
                        </>
                    }
                </>
            }
        />
    );
}
export default PaymentDetails;